import React, { useEffect, useState } from "react";
import { getCompanyLogo, subscribeCompany } from "../services/company.service.js";

// โลโก้แบรนด์ (มาร์ก + ชื่อ) ใช้ร่วมกันทั้งหน้า login navbar แอดมิน และเว็บฝั่งลูกค้า
// สไตล์อยู่ใน assets/css/style.css (คลาส .mn-logo)
//
// ใช้โลโก้ที่ผู้ดูแลอัปไว้ที่ "ตั้งค่า › ข้อมูลบริษัท" ถ้ายังไม่ได้ตั้ง (หรือโหลดไม่สำเร็จ)
// จะกลับไปใช้มาร์ก SVG ตั้งต้นด้านล่างเสมอ — ทุกจุดที่วางคอมโพเนนต์นี้เปลี่ยนพร้อมกัน
// โดยไม่ต้องรีโหลดหน้า (ดู services/company.service.js)
// มาร์กตั้งต้นของระบบ — ใช้เมื่อยังไม่ได้ตั้งโลโก้บริษัท
// แยกออกมาให้หน้าอื่นหยิบไปวางเป็นภาพตัวอย่างได้ (เช่น ช่องเลือกโลโก้หน้าตั้งค่า)
export function LogoMark({ size = 42, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 44 44" className={className} aria-hidden="true">
      <rect width="44" height="44" rx="12" fill="#142016" />
      <path d="M10 33V12l9.5 9.8V33H10Z" fill="#a3e635" />
      <path d="M24.5 33V21.8L34 12v21h-9.5Z" fill="#ffffff" />
    </svg>
  );
}

export default function Logo({ size = 42, sub = "LIFE LIVING", showText = true, version = false }) {
  const [logo, setLogo] = useState(getCompanyLogo);

  useEffect(() => subscribeCompany((company) => setLogo(company.logo || "")), []);

  return (
    <div className="mn-logo">
      {logo ? (
        <img
          className="mn-logo__img"
          src={logo}
          alt=""
          style={{ width: size, height: size }}
          /* โลโก้ที่บันทึกไว้เปิดไม่ได้ (ไฟล์ถูกลบ/ลิงก์เสีย) ให้ตกกลับไปใช้มาร์กตั้งต้น */
          onError={() => setLogo("")}
        />
      ) : (
        <LogoMark size={size} />
      )}
      {showText && (
        <div className="mn-logo__text">
          <div className="mn-logo__name mb-1">SafeSpace</div>
          {/* เวอร์ชันต่อท้ายบรรทัดรองในบรรทัดเดียวกัน (ใช้เฉพาะฝั่งแอดมิน) */}
          <div className="mn-logo__sub">
            {sub}
            {version && <span className="mn-logo__version">v{global.version}</span>}
          </div>
        </div>
      )}
    </div>
  );
}
